import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

const UpdateValueDialog = ({
  open,
  title = "Update",
  label = "Value",
  value = "",
  onClose,
  onSubmit,
  loading = false,
  submitText = "Update",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }
    setInputValue(value === 0 || value ? String(value) : "");
    setError("");
  }, [open, value]);

  const handleSubmit = async () => {
    if (inputValue === "" || Number.isNaN(Number(inputValue))) {
      setError(`${label} is required`);
      return;
    }
    if (Number(inputValue) < 0) {
      setError(`${label} cannot be negative`);
      return;
    }
    await onSubmit(Number(inputValue));
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ fontWeight: 600 }}>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          type="number"
          label={label}
          value={inputValue}
          error={Boolean(error)}
          helperText={error}
          disabled={loading}
          onChange={(event) => {
            setInputValue(event.target.value);
            setError("");
          }}
          onWheel={(event) => event.target.blur()}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleSubmit();
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button type="button" onClick={onClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          disableElevation
        >
          {loading ? "Updating..." : submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateValueDialog;
